var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueStorage(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E6ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2978 17.7518C30.8503 17.7518 30.4172 17.8138 30.0022 17.9234C30.0203 17.7371 30.0311 17.5472 30.0311 17.3536C30.0311 14.0701 27.4003 11.4074 24.156 11.4074C23.1492 11.4074 22.2037 11.6631 21.3773 12.116C20.1575 9.61409 17.6206 7.89014 14.6794 7.89014C10.551 7.89014 7.20566 11.276 7.20566 15.4544C7.20566 16.3017 7.35001 17.1162 7.60624 17.8796C5.09093 18.2047 3.14941 20.3669 3.14941 22.9967C3.14941 25.8237 5.39767 28.1211 8.18364 28.1576V28.1612L31.2978 28.2416C34.1595 28.2416 36.4799 25.8931 36.4799 22.9967C36.4799 20.1003 34.1595 17.7518 31.2978 17.7518Z",
    fill: "#4294FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2578 15.4617C11.2578 13.7889 12.6003 12.4302 14.2531 12.4302",
    stroke: "#E6ECFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0547 14.3843C26.0579 14.3843 26.8735 15.2097 26.8735 16.2251",
    stroke: "#E6ECFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStorage);
export default __webpack_public_path__ + "static/media/BlueStorage.23cdb76961292b7aea16df5df75e4cee.svg";
export { ForwardRef as ReactComponent };